import { adminServerInstance } from "../axios/instances";
import { GET_ALL_CLEARING_EVENTS,
    GET_ALL_CLEARING_EVENTS_SUCCESS,
    GET_ALL_CLEARING_EVENTS_FAIL,
    GET_ALL_CLEARING_ITEMS,
    GET_ALL_CLEARING_ITEMS_SUCCESS,
    GET_ALL_CLEARING_ITEMS_FAIL,
    CHANGE_BATCH_SEND_NO,
    TEXT_FUNCTION_OPEN,
    VERIFY_PARCEL_EXISTENCE,
    VERIFY_PARCEL_EXISTENCE_SUCCESS,
    VERIFY_PARCEL_EXISTENCE_FAIL,
    CREATE_CLEARING_EVENT,
    CREATE_CLEARING_EVENT_SUCCESS,
    CREATE_CLEARING_EVENT_FAIL,
    DELETE_CLEARING_EVENT,
    DELETE_CLEARING_EVENT_SUCCESS,
    DELETE_CLEARING_EVENT_FAIL,
    RETRIED_PLUS_ONE,
    RETRIED_PLUS_ONE_SUCCESS,
    RETRIED_PLUS_ONE_FAIL,
    BATCH_SEND_EXPIRED_ALERT,
    BATCH_SEND_EXPIRED_ALERT_SUCCESS,
    BATCH_SEND_EXPIRED_ALERT_FAIL ,
    GET_SMS_ALERT_HISTORY,
    GET_SMS_ALERT_HISTORY_SUCCESS,
    GET_SMS_ALERT_HISTORY_FAIL,
    TEST_BATCH_SEND_EXPIRED_ALERT,
    TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS,
    TEST_BATCH_SEND_EXPIRED_ALERT_FAIL,
    ABANDON_EXPIRED_PARCEL,
    ABANDON_EXPIRED_PARCEL_SUCCESS,
    ABANDON_EXPIRED_PARCEL_FAIL
} from './types';

export function abandonExpiredParcel(warehouse, batch_send_no){
    return function(dispatch){
        dispatch({type: ABANDON_EXPIRED_PARCEL})
        return adminServerInstance.post(`/storage/abandonexpiredparcel`, {
            warehouse: warehouse,
            batch_send_no: batch_send_no
        })
            .then(({data}) => {
                dispatch({
                    type: ABANDON_EXPIRED_PARCEL_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: ABANDON_EXPIRED_PARCEL_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}
    

export function handleTextFunctionOpen(admin, operator) {
    return function(dispatch){
    dispatch({type: TEXT_FUNCTION_OPEN})
    return (
        dispatch({
            type: TEXT_FUNCTION_OPEN,
            payload: admin ? 'admin' : operator
        })
    )}
}

export function handleBatchSendNochange(num) {
    return function(dispatch){
        dispatch({type: CHANGE_BATCH_SEND_NO})
        return (
            dispatch({
                type: CHANGE_BATCH_SEND_NO,
                payload: num
            })
        )}
}

export function getAllClearingEvents(){
    return function(dispatch){
        dispatch({type: GET_ALL_CLEARING_EVENTS})
        return adminServerInstance.get(`/storage/getallclearingevents?&version=1`)
            .then(({data}) => {
                dispatch({
                    type: GET_ALL_CLEARING_EVENTS_SUCCESS,
                    payload: data
                })
            }).catch(error => {
                dispatch({
                    type: GET_ALL_CLEARING_EVENTS_FAIL,
                    payload: error
                })
            });
    }
}

export function getAllClearingItems(batchSendNo){
    return function(dispatch){
        dispatch({type: GET_ALL_CLEARING_ITEMS})
        return adminServerInstance.get(`/storage/getallclearingitems?batch_send_no=${batchSendNo}&version=1`)
            .then(({data}) => {
                dispatch({
                    type: GET_ALL_CLEARING_ITEMS_SUCCESS,
                    payload: data
                })
            }).catch(error => {
                dispatch({
                    type: GET_ALL_CLEARING_ITEMS_FAIL,
                    payload: error
                })
            });
    }
}

export function verifyParcelExistence(tno, batchSendNo){
    return function(dispatch){
        dispatch({type: VERIFY_PARCEL_EXISTENCE})
        return adminServerInstance.post(`/storage/scanparcelexist`, {
            batch_send_no: batchSendNo,
            tno: tno
        })
        .then(({data}) => {
            dispatch({
                type: VERIFY_PARCEL_EXISTENCE_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: VERIFY_PARCEL_EXISTENCE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function createClearingEvent(warehouseNo, storage_info_end) {
    return function(dispatch){
        dispatch({type: CREATE_CLEARING_EVENT})
        return adminServerInstance.post(`/storage/createclearingevent`, {
            warehouse: warehouseNo,
            storage_info_end: storage_info_end
        })
        .then(({data}) => {
            dispatch({
                type: CREATE_CLEARING_EVENT_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: CREATE_CLEARING_EVENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function deleteClearingEvent(batch_send_no, warehouseNo) {
    return function(dispatch){
        dispatch({type: DELETE_CLEARING_EVENT})
        return adminServerInstance.post(`/storage/deleteclearingevent`, {
            batch_send_no: batch_send_no,
            warehouse: warehouseNo,

        })
        .then(({data}) => {
            dispatch({
                type: DELETE_CLEARING_EVENT_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: DELETE_CLEARING_EVENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function retrySmsOneMore(warehouse, batch_send_no, tno, send_msg) {
    return function(dispatch){
        dispatch({type: RETRIED_PLUS_ONE})
        return adminServerInstance.get(`/storage/retrysmsonemore?batch_send_no=${batch_send_no}&tno=${tno}&send_msg=${send_msg}&warehouse=${warehouse}`).then(({data}) => {
            dispatch({
                type: RETRIED_PLUS_ONE_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: RETRIED_PLUS_ONE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function batchSendExpiredAlert(batch_send_no, warehouse) {
    return function(dispatch){
        dispatch({type: BATCH_SEND_EXPIRED_ALERT})
        return adminServerInstance.post(`/storage/batchsendexpiredalert`, {
            batch_send_no: batch_send_no,
            warehouse: warehouse,
        }).then(({data}) => {
            dispatch({
                type: BATCH_SEND_EXPIRED_ALERT_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: BATCH_SEND_EXPIRED_ALERT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getSmsAlertHistory(batch_send_no, tno, warehouse) {
    return function(dispatch){
        dispatch({type: GET_SMS_ALERT_HISTORY})
        return adminServerInstance.get(`/storage/getsmsalerthistory?batch_send_no=${batch_send_no}&tno=${tno}&warehouse=${warehouse}`).then(({data}) => {
            dispatch({
                type: GET_SMS_ALERT_HISTORY_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: GET_SMS_ALERT_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function testBatchSendExpiredAlert(batch_send_no, warehouse, mobile) {
    return function(dispatch){
        dispatch({type: TEST_BATCH_SEND_EXPIRED_ALERT})
        return adminServerInstance.post(`/storage/testbatchsendexpiredalert`, {
            batch_send_no: batch_send_no,
            warehouse: warehouse,
            mobile: mobile
        })
        .then(({data}) => {
            dispatch({
                type: TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: TEST_BATCH_SEND_EXPIRED_ALERT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
